'use client';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window.gtag === 'undefined') return;

    const search = searchParams.toString();
    const page_path = pathname + (search ? `?${search}` : '');
    const page_location = window.location.href;
    const page_title = document.title;

    // Send custom page_view event
    window.gtag('event', 'page_view', {
      page_location,
      page_path,
      page_title,
    });

    // Dev-only console log
    if (process.env.NODE_ENV !== 'production') {
      console.log('[GA] page_view', page_path);
    }
  }, [pathname, searchParams]);

  return null;
}